import { useEffect, useRef, useState } from 'react';

interface ObserverOptions {
  once: boolean;
  threshold: number;
  root?: Element | Document | null;
  rootMargin?: string;
}

export const utilIntersectionObserver = (options: ObserverOptions) => {
  const ref = useRef(null);
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsIntersecting(entry.isIntersecting);

      if (entry.isIntersecting && options?.once) {
        observer.unobserve(entry.target);
      }
    }, options);

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [options]);

  return { ref, isIntersecting };
};
